const loadImage = (src) =>
  new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => res(img);
    img.onerror = rej;
    img.src = src;
  });

export async function fileToLogo(file, max = 400) {
  const src = await new Promise((res) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.readAsDataURL(file);
  });
  const img = await loadImage(src);
  const scale = Math.min(1, max / Math.max(img.width, img.height));
  const c = document.createElement("canvas");
  c.width = Math.round(img.width * scale);
  c.height = Math.round(img.height * scale);
  c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
  return c.toDataURL("image/png");
}

export async function fileToPhoto(file, max = 600) {
  if (!file.type.startsWith("image/")) throw new Error("File harus berupa gambar (JPG/PNG/WEBP)");
  if (file.size > 15 * 1024 * 1024) throw new Error("Ukuran gambar maksimal 15 MB");
  const src = URL.createObjectURL(file);
  try {
    const img = await loadImage(src).catch(() => { throw new Error("Gambar tidak dapat dibaca, coba format JPG/PNG"); });
    const scale = Math.min(1, max / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale);
    c.height = Math.round(img.height * scale);
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL("image/jpeg", 0.82);
  } finally {
    URL.revokeObjectURL(src);
  }
}

// Converts an image to ESC/POS raster bytes (GS v 0) for thermal printers
export async function imageToRaster(src, width = 256, maxHeight = 160) {
  const img = await loadImage(src);
  let w = Math.min(width, img.width * 2);
  let h = Math.round((img.height * w) / img.width);
  if (h > maxHeight) {
    w = Math.round((w * maxHeight) / h);
    h = maxHeight;
  }
  w = Math.max(8, Math.floor(w / 8) * 8);
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(img, 0, 0, w, h);
  const px = ctx.getImageData(0, 0, w, h).data;
  const bw = w / 8;
  const out = [0x1d, 0x76, 0x30, 0, bw & 255, bw >> 8, h & 255, h >> 8];
  for (let y = 0; y < h; y++) {
    for (let xb = 0; xb < bw; xb++) {
      let byte = 0;
      for (let bit = 0; bit < 8; bit++) {
        const i = (y * w + xb * 8 + bit) * 4;
        const lum = 0.299 * px[i] + 0.587 * px[i + 1] + 0.114 * px[i + 2];
        if (lum < 150) byte |= 0x80 >> bit;
      }
      out.push(byte);
    }
  }
  return out;
}
